<div class="px-md-5 px-3 pt-5 pb-2 footer" id="footer">
  <div class="d-flex justify-content-around align-items-center text-uppercase" style="margin-bottom: 100px">
    <!-- <p>Take a look +</p> -->

    <div class="d-flex flex-column justify-content-center align-items-center">
      <p class="mb-0" style="color: #8C8B8D;">(45°27'8.98'' - 9°14'47.734'')</p>
      <p class="text-center lh-sm" style="font-size: 40px">76/B Via Mecenate,<br> Milan, Italy</p>
    </div>

    <!-- <p>+ Sneak peak</p> -->
  </div>

  <div
    class="d-flex justify-content-between flex-md-row flex-column align-items-md-start align-items-center gap-md-0 gap-5"
    style="margin-bottom: 150px">
    <div class="d-flex flex-column text-uppercase align-items-md-start align-items-center socials order-md-0 order-1">
      <p class="mb-1">Follow us on:</p>

      <a>
        <img class="social-icon" src="/assets/img/instagram.svg" alt="Instagram">
        <p>Instagram</p>
      </a>

      <a>
        <img src="/assets/img/linkedin.svg" alt="Linkedin">
        <p>Linkedin</p>
      </a>

      <a>
        <img src="/assets/img/twitter-x.svg" alt="X">
        <p>X</p>
      </a>
    </div>

    <div class="email order-md-1 order-0">
      <a href="mailto:info@mecenateartcorner.com">info&commat;mecenateartcorner.com</a>
    </div>


    <div class="d-flex flex-column align-items-md-start align-items-center text-uppercase companies order-2">
      <p>A project of:</p>
      <p>Modular Labs</p>
      <p>Bitveil</p>
    </div>
  </div>

  <div class="logo-container" [style.gridTemplateColumns]="logoAlternative ? '25% 75%' : '75% 25%'">
    <img src="/assets/img/mac.svg" (mouseenter)="changeLogo(false)">
    <img src="/assets/img/76B25.svg" (mouseenter)="changeLogo(true)">
  </div>

  <div class="d-md-flex justify-content-between text-uppercase d-none">
    <div class="d-flex gap-5 footer-bottom">
      <p>P.IVA 01976590495</p>
      <a routerLink="privacy">Privacy</a>
      <a routerLink="terms">Policy</a>
    </div>

    <p>© 2024 MAC76B25</p>
  </div>

  <div class="d-md-none footer-bottom-mobile">
    <div class="text-uppercase">
      <div class="d-flex gap-5 footer-bottom justify-content-between">
        <p>P.IVA 01976590495</p>
        <div class="d-flex gap-3">
          <a routerLink="privacy">Privacy</a>
          <a routerLink="terms">Policy</a>
        </div>
      </div>
    </div>

    <p>© 2024 MAC76B25</p>
  </div>

</div>